$(function() {
  return $(document).on('keyup', '#item_value, #item_quantity', function() {
    calculateTotal()
    calculateSubtotal()
    calculateIva()
    calculateIco()
  })
})

$(function() {
  return $(document).on('change', '#item_value, #item_quantity', function() {
    calculateTotal()
    calculateSubtotal()
    calculateIva()
    calculateIco()
  })
})

$(function() {
  return $(document).on('change', '#item_iva_percent', function() {
    calculateTotal()
    calculateSubtotal()
    calculateIva()
    calculateIco()
  })
})

$(function() {
  return $(document).on('change', '#item_ico_percent', function() {
    calculateTotal()
    calculateSubtotal()
    calculateIva()
    calculateIco()
  })
})


function calculateTotal() {
  item_total = 0
  if (parseFloat($("#item_value").val()) > 0){
    item_total = parseFloat($("#item_value").val())
  }

  item_quantity = 0
  if (parseFloat($("#item_quantity").val()) > 0){
    item_quantity = parseFloat($("#item_quantity").val())
  }

  total = item_quantity * item_total
  $("#item_total").val(total)  
  $(".cart-total").text('$' + Intl.NumberFormat().format(parseFloat(total)))
}

function calculateIva(){
  item_total = 0
  if (parseFloat($("#item_total").val()) > 0){
    item_total = parseFloat($("#item_total").val())
  }

  iva_percent = parseFloat($("#item_iva_percent").val())
  subtotal = parseFloat($("#item_subtotal").val())
  iva = subtotal * (iva_percent / 100)
  $("#item_iva_value").val(iva)
}


function calculateIco(){
  item_total = 0
  if (parseFloat($("#item_total").val()) > 0){
    item_total = parseFloat($("#item_total").val())
  }

  ico_percent = parseFloat($("#item_ico_percent").val())
  subtotal = parseFloat($("#item_subtotal").val())
  ico = subtotal * (ico_percent / 100)
  $("#item_ico_value").val(ico)
}

function calculateSubtotal(){
  item_total = 0
  if (parseFloat($("#item_total").val()) > 0){
    item_total = parseFloat($("#item_total").val())
  }

  iva = parseFloat($("#item_iva_percent").val() || 0)
  ico = parseFloat($("#item_ico_percent").val() || 0)

  subtotal = item_total / (1 + ((iva + ico) / 100))

  $("#item_subtotal").val(subtotal)
  $(".cart-subtotal").text('$' + Intl.NumberFormat().format(parseFloat(subtotal)))
}


$(function() {
  return $(document).on('change', '#bags_quantity', function() {
    bags_quantity = $('#bags_quantity').val()
    // Impuesto 2026 -> 73COP

    amount = bags_quantity * 73
  
    $('#bags_amount').text('$' + Intl.NumberFormat().format(parseFloat(amount)))
  })
})
